import { render, staticRenderFns } from "./Shooting.vue?vue&type=template&id=0c6f6cec&scoped=true&"
import script from "./Shooting.vue?vue&type=script&lang=js&"
export * from "./Shooting.vue?vue&type=script&lang=js&"
import style0 from "./Shooting.vue?vue&type=style&index=0&id=0c6f6cec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6f6cec",
  null
  
)

/* custom blocks */
import block0 from "./Shooting.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports